<h1 mat-dialog-title>{{this.cr.id ? "Edit" : "New"}} Claim Reason Code</h1>
<div mat-dialog-content>

    <form class="example-form">

        <lf-select-search [listElements]="product_types" placeholder="Product Type *" placeholderLabel="product type"
            (selected)="this.onProductTypeChanged($event)" [selectedElementId]="cr.product_type_id"
            [disabled]="this.categoryLevel == true" />

        <mat-checkbox [(ngModel)]="categoryLevel" [ngModelOptions]="{standalone: true}" (change)="cr.product_type_id = null">Apllicable to all</mat-checkbox>

        <br>

        <mat-form-field class="example-full-width" style="width: 100%;">
            <mat-label>Claim Reason Code *</mat-label>
            <input matInput #cr_claim_name [(ngModel)]='cr.claim_name' [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <table>
            <tr>
                <td>
                    <mat-form-field>
                        <mat-label>Effective date *</mat-label>
                        <input matInput [matDatepicker]="picker1" [min]="minDate"
                            [(ngModel)]="cr.effective_date" [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="picker1" />
                        <mat-datepicker #picker1 />
                    </mat-form-field>
                </td>

                <td>
                    <mat-form-field>
                        <mat-label>Valid to</mat-label>
                        <input matInput [matDatepicker]="picker2" [min]="minDate"
                            [(ngModel)]="cr.invalid_date" [ngModelOptions]="{standalone: true}">
                        <mat-datepicker-toggle matSuffix [for]="picker2" />
                        <mat-datepicker #picker2 />
                    </mat-form-field>
                </td>
            </tr>
        </table>

    </form>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button (click)="onOkClick()" cdkFocusInitial>Ok</button>
</div>
